import { defaultHttpClient } from '../../httpClient';

export const disagreeNotificationAlarm = async (code: string) => {
  return defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/members/me/notification-agreements/`,
    data: { code: code },
  });
};
